<div class="aa-input-general">
  <div class="text-general-title mb-6 text-(--color-segundo)">
    {{ 'quotation.titles.leasePremises' | translate }}
  </div>
  <form [formGroup]="financialValuesGroup" class="form">
    <div
      class="grid gap-5"
      [ngClass]="{
        'grid-cols-1': colummNum === 1,
        'grid-cols-1 lg:grid-cols-2 xl:grid-cols-2': colummNum === 2,
        'grid-cols-1 lg:grid-cols-3 xl:grid-cols-3': colummNum === 3,
      }"
    >
      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.car' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.labels.totalPriceVat' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="CostVat"
                formControlName="costVat"
                maxlength="10"
                autocomplete="off"
                (change)="onCostValidateNotZero($event)"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                min="1"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.discountedPrice' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="CostDiscount"
                formControlName="costDiscount"
                autocomplete="off"
                (change)="onBlurCost($event)"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>
          @if (planType !== 1) {
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">{{
                'quotation.fieldNames.advanceRents' | translate
              }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  name="AdvanceRent"
                  formControlName="advanceRent"
                  autocomplete="off"
                  (change)="onBlurCost($event)"
                  [mask]="'separator'"
                  [allowNegativeNumbers]="true"
                />
              </mat-form-field>
            </div>

            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">{{
                'quotation.fieldNames.warrantyRents' | translate
              }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  name="WarrantyRent"
                  formControlName="warrantyRent"
                  autocomplete="off"
                  (change)="onBlurCost($event)"
                  [mask]="'separator'"
                  [allowNegativeNumbers]="true"
                />
              </mat-form-field>
            </div>
          } @else {
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">{{
                'quotation.fieldNames.hookAmount' | translate
              }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  name="Enganche"
                  formControlName="enganche"
                  autocomplete="off"
                  [thousandSeparator]="','"
                  [prefix]="'$'"
                  (change)="onBlurCost($event)"
                  [mask]="'separator'"
                  [allowNegativeNumbers]="true"
                />
              </mat-form-field>
            </div>
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">{{
                'quotation.fieldNames.hookPercentaje' | translate
              }}</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  name="PorEnganche"
                  formControlName="porEnganche"
                  autocomplete="off"
                  (change)="onBlurCost($event)"
                  [mask]="'separator'"
                  [suffix]="'%'"
                  [allowNegativeNumbers]="true"
                />
              </mat-form-field>
            </div>
          }
          @if (applyLeaseLine === 1) {
            <div class="h-18.25 flex items-center pb-5.5">
              <mat-checkbox
                formControlName="isOnLeaseLine"
                (change)="onLeaseLine($event.checked)"
                >{{ 'quotation.labels.leaseLineAdvice' | translate }}</mat-checkbox
              >
            </div>
          }
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.insurances' | translate }}
        </div>

        <div class="">
          <div class="h-18.25 flex items-center pb-5.5">
            <mat-checkbox
              formControlName="isSegAnual"
              (change)="onAnnualInsurance($event.checked)"
              >{{ 'Seguro anualizado' | translate }}</mat-checkbox
            >
          </div>

          @if (financialValuesGroup.get('isSegAnual')?.value) {
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">
                VALOR DEL SEGURO ANUAL
              </mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [prefix]="'$'"
                  [thousandSeparator]="','"
                  [mask]="'separator'"
                  [allowNegativeNumbers]="true"
                  name="SegAnualCot"
                  autocomplete="off"
                  formControlName="segAnualCot"
                  (change)="onBlurCost($event)"
                />
              </mat-form-field>
            </div>
          } @else {
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">
                VALOR DEL SEGURO
              </mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  [prefix]="'$'"
                  [thousandSeparator]="','"
                  [mask]="'separator'"
                  [allowNegativeNumbers]="true"
                  name="ActiveInsuranceAmount"
                  autocomplete="off"
                  formControlName="activeInsuranceAmount"
                  (change)="onBlurCost($event)"
                />
              </mat-form-field>
            </div>
          }

          <!-- Jorge pidio ocultarlo
          @if (selectedProgram.description == 'SEGURO ABIERTO') {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label class="text-(--comp-input-label-normal) px-4">
                @if (selectedProgram.description == 'SEGURO ABIERTO') {
                  {{ 'quotation.fieldNames.insuranceValue' | translate }}
                </mat-label>
                }
                <input
                matInput
                formControlName="activeInsuranceAmount"
                name="ActiveInsuranceAmount"
                autocomplete="off"
                (change)="onBlurCost($event)"
                />
              </mat-form-field>
              } -->

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.insurancePayment' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="input-mat-form-field w-full">
              <mat-select
                class="small-select"
                formControlName="insurancePayment"
                id="InsurancePaymentId"
                (selectionChange)="insurancePayChange($event)"
              >
                @for (insurancePay of insurancePayments; track insurancePay.id) {
                  <mat-option [value]="insurancePay.id">
                    {{ insurancePay.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!--  id="AnualnsuranceAmount" -->

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.annualInsurance' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="input-mat-form-field w-full">
              <mat-select
                formControlName="annualInsurance"
                class="small-select"
                (selectionChange)="segAnualChange($event)"
              >
                @for (segAnual of annualInsurances; track segAnual.id) {
                  <mat-option [value]="segAnual.id">
                    {{ segAnual.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.assetUse' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="input-mat-form-field w-full">
              <mat-select
                formControlName="vehicleUseId"
                id="VehicleUseId"
                class="small-select"
                (selectionChange)="vehicleUseDataChange($event)"
              >
                @for (vehicleUse of vehicleUses; track vehicleUse.id) {
                  <mat-option [value]="vehicleUse.id">
                    {{ vehicleUse.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.information' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.gps' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="GpsTotal"
                formControlName="gpsTotal"
                maxlength="10"
                autocomplete="off"
                (change)="onBlurCost($event)"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.gpsPayments' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="input-mat-form-field w-full">
              <mat-select
                formControlName="gpsTipoPago"
                id="GpsTipoPago"
                class="small-select"
                (selectionChange)="gpsTipoPagoChange($event)"
              >
                <mat-option [value]="2">
                  {{ 'quotation.fieldNames.financed' | translate }}
                </mat-option>
                <mat-option [value]="1">
                  {{ 'quotation.fieldNames.cash' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.accessoriesFinancedVat' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="accessoriesFinancedVat"
                autocomplete="off"
                readonly="true"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">
              {{ 'quotation.fieldNames.accessoriesFinancedTotalAmount' | translate }}
            </mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="accessoriesFinancedTotalAmount"
                autocomplete="off"
                readonly="true"
              />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.vat' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="vat" autocomplete="off" readonly="true" />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-form-field appearance="outline" class="" style="display: none">
              <mat-label class="" style="display: none">-</mat-label>
              <input matInput />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.fieldNames.rate' | translate }}
        </div>
        <div class="w-full alone">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.percentage' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="nRate"
                name="NRate"
                autocomplete="off"
                [suffix]="'%'"
                [mask]="'separator'"
                (change)="onChangenonNumtoString($event)"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.quoteComission' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.percentage' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="NCommission"
                (change)="onChangenonNumtoString($event)"
                formControlName="nCommission"
                autocomplete="off"
                [suffix]="'%'"
                [mask]="'separator'"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="border-[--brand-azul-primario]" style="display: none">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.markUp' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.amount' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input matInput />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.percentage' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input matInput />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center font-normal text-base">
          {{ 'quotation.fieldNames.procedures' | translate }}
        </div>
        <div class="w-full alone">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.amount' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                readonly="true"
                formControlName="procedures"
                autocomplete="off"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.otherConcepts' | translate }}
        </div>
        <div class="w-full">
          <div class="widthInput">
            <mat-checkbox style="display: none">
              <div>{{ 'quotation.fieldNames.monthlyPaymentNoVat' | translate }}</div></mat-checkbox
            >
            <mat-checkbox
              formControlName="advanceWarrantyRent"
              name="AdvanceWarrantyRent"
              (change)="onChangeEarlyRentData($event)"
            >
              <div>
                @if (planType !== 1) {
                  {{ 'quotation.fieldNames.advanceWarrantyRent' | translate }}
                } @else {
                  {{ 'quotation.fieldNames.monthlyPaymentNoVat' | translate }}
                }
              </div></mat-checkbox
            >
            <mat-checkbox
              formControlName="noContractRatification"
              name="NoContractRatification"
              (change)="onChangenoContractRatificationData($event)"
            >
              <div>
                {{ 'quotation.fieldNames.noContractRatification' | translate }}
              </div></mat-checkbox
            >
          </div>
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">
              {{ 'quotation.fieldNames.contractRatificationNoVat' | translate }}
            </mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="contractRatificationNoVat"
                maxlength="10"
                name="ContractRatificationNoVat"
                autocomplete="off"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                (change)="onChangenonNumtoString($event)"
              />
            </mat-form-field>
          </div>
          @if (planType !== 1) {
            <div class="gap-1 flex flex-col">
              <mat-label class="text-(--comp-input-label-normal) px-4">
                {{ 'quotation.fieldNames.extraordinaryContribution' | translate }}
              </mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  name="PartialCharge"
                  formControlName="partialCharge"
                  autocomplete="off"
                  (change)="onChangenonNumtoString($event)"
                  [mask]="'separator'"
                  [prefix]="'$'"
                  [thousandSeparator]="','"
                  [allowNegativeNumbers]="true"
                />
              </mat-form-field>
            </div>
          }
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.fieldNames.residualValue' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.amount' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="ResidualValueAmount"
                (change)="onChangenonNumtoString($event)"
                formControlName="residualValueAmount"
                autocomplete="off"
                [mask]="'separator'"
                [prefix]="'$'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
              />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.percentage' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="ResidualValuePercentage"
                (change)="onChangenonNumtoString($event)"
                formControlName="residualValuePercentage"
                autocomplete="off"
                [suffix]="'%'"
                [mask]="'separator'"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-4">
        <div class="text-(--color-segundo) items-center text-general-title">
          {{ 'quotation.titles.additionals' | translate }}
        </div>
        <div class="w-full">
          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4"
              >{{ 'quotation.fieldNames.srs' | translate }}:</mat-label
            >
            <mat-form-field appearance="outline" class="" style="display: none">
              <input matInput formControlName="srs" autocomplete="off" readonly="true" />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4"
              >{{ 'quotation.fieldNames.card' | translate }}:</mat-label
            >
            <mat-form-field appearance="outline" class="" style="display: none">
              <input matInput formControlName="card" autocomplete="off" readonly="true" />
            </mat-form-field>
          </div>

          <div class="gap-1 flex flex-col">
            <mat-label class="text-(--comp-input-label-normal) px-4">{{
              'quotation.fieldNames.fleet' | translate
            }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                name="Fleet"
                formControlName="fleet"
                autocomplete="off"
                (change)="onBlurCost($event)"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="px-4! py-1.5! w-full flex flex-row-reverse border-primary border-b">
  <div class="flex">
    <button matIconButton [matTooltip]="'3 columnas'" (click)="colummNum = 3">
      <mat-icon class="mb-1.25">view_cozy</mat-icon>
    </button>

    <button matIconButton [matTooltip]="'2 columnas'" (click)="colummNum = 2">
      <mat-icon class="mb-1.25">view_cozy</mat-icon>
    </button>

    <button matIconButton [matTooltip]="'1 columna'" (click)="colummNum = 1">
      <mat-icon class="mb-1.25">splitscreen_portrait</mat-icon>
    </button>
  </div>
</div>
